export const PAY_BILLS_ACTIONS_TYPES = {
  FETCH_SELECTED_COUNTRY: 'FETCH_SELECTED_COUNTRY',
  FETCH_PROVIDERS: 'FETCH_PROVIDERS',
  FETCH_WALLETS: 'FETCH_WALLETS',
  SELECTED_WALLET: 'SELECTED_WALLETS',
  REQUEST_GATEWAY_VERIFY_ACCOUNT: 'REQUEST_GATEWAY_VERIFY_ACCOUNT',
  GET_COUNTRIES: 'GET_COUNTRIES',
  FETCH_LOCATED_USERS: 'FETCH_LOCATED_USERS',
};
